import { render, staticRenderFns } from "./PosEventForm.vue?vue&type=template&id=681d04ed&"
import script from "./PosEventForm.vue?vue&type=script&lang=js&"
export * from "./PosEventForm.vue?vue&type=script&lang=js&"
import style0 from "./PosEventForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports